export const setCaCertificateData = (data, title) => {
  const postData = {
    certData: `${data}`,
    certGroups: null,
    certName: `${title}`,
    verifyAuthChain: false,
    verifyValidity: false,
  };
  return postData;
};

export const setTrustedCertificateData = (data, title) => {
  const postData = {
    certData: `${data}`,
    certGroups: null,
    certName: `${title}`,
    verifyAuthChain: false,
    verifyValidity: false,
  };
  return postData;
};

export const setMailboxData = (as2Name) => {
  const mailboxData = {
    createParentMailbox: false,
    description: `${as2Name}`,
    groups: "JD_B2B Integrator Biz",
    linkedToMailbox: null,
    mailboxType: "R",
    path: `/app_data/B2Bi/mailbox/EDI_${as2Name}`,
    users: "sp76477,admin,MBX_daemon",
  };
  return mailboxData;
};

export const setMailboxRawData = (as2Name, type) => {
  const mailboxData = {
    createParentMailbox: false,
    description: `${type}`,
    groups: "JD_B2B Integrator Biz",
    linkedToMailbox: null,
    mailboxType: "R",
    path: `/app_data/B2Bi/mailbox/EDI_${as2Name}/${type}`,
    users: "admin,MBX_daemon",
  };
  return mailboxData;
};

export const setAs2PartnerData = (
  as2Id,
  caCertName,
  trustCertName,
  partnerEndpoint,
  identityName,
  adapterNode,
  encryptionAlg,
  signingAlg,
  enableCaCertificate = true
) => {
  const httpClientAdapters = [
    "JD_HTTPClient_node1AC1_external",
    "JD_HTTPClient_node2AC1_external",
  ];
  const partnerData = {
    additionalHttpCommunication: null,
    as2Identifier: `${as2Id}`,
    cipherStrength: "STRONG",
    compressData: "default",
    deliveryMode: "0",
    encryptionAlgorithm: `${encryptionAlg}`,
    endPoint: `${partnerEndpoint}`,
    exchangeCertSelectionPolicy: "1",
    exchangeCertificate: [
      {
        certName: `${trustCertName}`,
        certificateOrder: 1,
        goLiveDate: null,
        notAfterDate: null,
      },
    ],
    firewallConnectCount: null,
    firewallProxy: null,
    httpClientAdapter: `${
      adapterNode ? httpClientAdapters[0] : httpClientAdapters[1]
    }`,
    identityName: `${identityName}`,
    keyCertificate: null,
    keyCertificatePassphrase: null,
    keyCertificateSelectionPolicy: "1",
    mdnReceipt: true,
    mimeSubType: "EDI-X12",
    mimeType: "Application",
    password: null,
    payloadType: "4",
    profileName: `${identityName}`,
    receiptSignatureType: "6",
    receiptTimeout: 300,
    receiptToAddress: "https://globaledi-as2-t.johndeere.com/as2",
    responseTimeout: 360,
    selectNewIdentity: true,
    setUpAdditionalServerCommunication: false,
    signingAlgorithm: `${signingAlg}`,
    signingCertSelectionPolicy: "1",
    signingCertificate: [
      {
        certName: `${trustCertName}`,
        certificateOrder: 1,
        goLiveDate: null,
        notAfterDate: null,
      },
    ],
    socketTimeout: null,
    ssl: "SSL_NONE",
    useExistingIdentity: null,
    userId: null,
  };

    if (enableCaCertificate) {
        partnerData.CACertSelectionPolicy = "1"
        partnerData.ssl = "SSL_MUST";
        partnerData.caCertificate = [
            {
                certName: `${caCertName}`,
                certificateOrder: 1,
                goLiveDate: null,
                notAfterDate: null,
            },
        ];
    }

  return partnerData;
};

export const setRelationshipData = (as2Id, mailId) => {
    const relationshipData = {
        "AS2Organisation": process.env.REACT_APP_AS2_ORGANIZATION_ID,
        "AS2TradingPartner": `${as2Id}`,
        "collectionFolder": null,
        "errorLogFolder": null,
        "extractionFolder": null,
        "inboundErrorBusinessProcess": null,
        "inboundSuccessBusinessProcess": null,
        "includeFileNameInMessage": null,
        "maxFilestoCollect": null,
        "maxRetries": 5,
        "notifyOnFinalFailure": true,
        "notifyOnIntermediateFailures": false,
        "retryInterval": 300,
        "runServiceBasedOnTimerEvery": null,
        "selectExistingParentMailbox": `${mailId}`,
        "setMessageFileNameinProcessData": false,
        "storeOrInvokeBP": "mailbox",
        "useDefaultInboundOrOutboundMailbox": false,
        "useMessageFileNametoSaveFile": false,
        "waitForSynchronousMDNProcessToCompleteBeforeExtractingData": false,
    }
    return relationshipData;
}

export const setRoutingRuleData = (as2Name, type) => {
  const routingRuleData = {
    businessProcess: "JD_IB_Rule_EDI",
    mailboxPath: `/app_data/B2Bi/mailbox/EDI_${as2Name}/${type}`,
  };
  return routingRuleData;
};

export const setRoutingRuleRawData = (as2Name, type) => {
  const routingRuleData = {
    businessProcess: "JD_EDIRaw_Send_Path",
    mailboxPath: `/app_data/B2Bi/mailbox/EDI_${as2Name}/${type}`,
  };
  return routingRuleData;
};

export const setCodeListData = (as2Id, suppNumber) => {
  const codeListData = {
    listName: process.env.REACT_APP_LIST_NAME,
    senderItem: `${as2Id}`,
    receiverItem: `${suppNumber}`,
    description: "CREATED WITH AS2 SELF SERVICE",
  };
  return codeListData;
};

export const setMailData = (mail, name) => {
  const mailData = {
    html: true,
    recipients: [`${mail}`],
    subject: "AS2 TRADING PARTNER RELATIONSHIP CONFIRMATION",
    from: "B2BiTech@JohnDeere.com",
    body: `*** Do not reply to this email.***<br><br>The ${name} AS2 trading partner was created<br><br><font color='red'>CONFIDENTIALITY. <i>This electronic mail and any files transmitted with it may contain information proprietary to Deere & Company, or one of its subsidiaries or affiliates, and are intended solely for the use of the individual or entity to whom they are addressed, shall be maintained in confidence and not disclosed to third parties without the written consent of the sender. If you are not the intended recipient or the person responsible for delivering the electronic mail to the intended recipient, be advised that you have received this electronic mail in error and that any use, dissemination, forwarding, printing, or copying of this electronic mail is strictly prohibited. If you have received this electronic mail in error, please immediately notify the sender by return mail.</i></font>`,
  };
  return mailData;
};

export const setUpdateMailData = (mail, name) => {
  const mailData = {
    html: true,
    recipients: [`${mail}`],
    subject: "AS2 TRADING PARTNER RELATIONSHIP CONFIRMATION",
    from: "B2BiTech@JohnDeere.com",
    body: `*** Do not reply to this email.***<br><br>The ${name} AS2 trading partner was updated<br><br><font color='red'>CONFIDENTIALITY. <i>This electronic mail and any files transmitted with it may contain information proprietary to Deere & Company, or one of its subsidiaries or affiliates, and are intended solely for the use of the individual or entity to whom they are addressed, shall be maintained in confidence and not disclosed to third parties without the written consent of the sender. If you are not the intended recipient or the person responsible for delivering the electronic mail to the intended recipient, be advised that you have received this electronic mail in error and that any use, dissemination, forwarding, printing, or copying of this electronic mail is strictly prohibited. If you have received this electronic mail in error, please immediately notify the sender by return mail.</i></font>`,
  };
  return mailData;
};

export const setContractData=(as2Id)=>{

    const contactData=
        {
        "prodProfileId":process.env.REACT_APP_AS2_ORGANIZATION_ID,
        "consumeProfileId":as2Id,
        "workflowName":process.env.REACT_APP_AS2_CONTRACT_WORKFLOW_NAME
    }
    return contactData;
}

//FGIV1AI - Validates every field since those are optional
function buildSupplierString(supplier_qualifier, supplier_isa_id, supplier_gs_id) {
    var out = "";

    // 1) QUALIFIER
    if (supplier_qualifier) {
        out += "QUALIFIER: " + supplier_qualifier;
        if (supplier_isa_id || supplier_gs_id) out += "    ";
    }

    // 2) ISA ID
    if (supplier_isa_id) {
        out += "ISA ID: " + supplier_isa_id;
        if (supplier_gs_id) out += "   ";
    }

    // 3) GS ID
    if (supplier_gs_id) {
        out += "GS ID: " + supplier_gs_id;
    }

    return out;
}

export const setNotificationMailData = (suppliers_email, supplier_number, title, text, supplier_qualifier = null, supplier_isa_id = null, supplier_gs_id = null, ) => {
  // Construir la línea de IDs opcionales solo si al menos uno está presente
  const idsLine = (supplier_isa_id || supplier_gs_id || supplier_qualifier)
    ? `<p style="mso-margin-top-alt: 0in; margin-right: 0in; margin-bottom: 2.4pt; margin-left: 0in;">
         <b><i><span style="font-size: 12pt; font-family: 'Arial', sans-serif; color: #3b7d23; mso-ligatures: standardcontextual;">
           ${buildSupplierString(supplier_qualifier, supplier_isa_id, supplier_gs_id)}
         </span></i></b>
       </p>`
    : '';

  const mailData = {
    html: true,
    recipients: [suppliers_email],
    subject: "John Deere Self Service EDI Notification",
    from: "johndeereglobaledicommunicationsdonotreply@johndeere.com",
    body: `<div align="center">
	<table border="1" cellspacing="0" cellpadding="0" width="684" style="width: 512.85pt; background: white; border: solid #cfcfcf 1pt">
		<tbody>
			<tr style="height: 351.75pt">
				<td width="100%" colspan="2" valign="top" style="width: 100%; border: solid #cfcfcf 1pt; border-bottom: none; padding: 6pt 12pt 6pt 18.75pt; height: 351.75pt;">
					<p style="mso-margin-top-alt: 0in; margin-right: 0in; margin-bottom: 2.4pt; margin-left: 0in;">
						<b><i><span style="font-size: 18pt; font-family: 'Arial', sans-serif; color: #3b7d23; mso-ligatures: standardcontextual;"><o:p>&nbsp;</o:p></span></i></b>
					</p>
					<p style="mso-margin-top-alt: 0in; margin-right: 0in; margin-bottom: 2.4pt; margin-left: 0in;">
						<b><i><span style="font-size: 11pt; mso-ligatures: standardcontextual;"><o:p>&nbsp;</o:p></span></i></b>
					</p>
					<p style="mso-margin-top-alt: 0in; margin-right: 0in; margin-bottom: 2.4pt; margin-left: 0in;">
						<b><i><span style="font-size: 18pt; font-family: 'Arial', sans-serif; color: #3b7d23; mso-ligatures: standardcontextual;">John Deere Supplier #${supplier_number}</span></i></b>
						<b><i><span style="font-size: 11pt; font-family: 'Arial', sans-serif; color: #3b7d23; mso-ligatures: standardcontextual;"><o:p></o:p></span></i></b>
					</p>
					</p>
					  ${idsLine}
					<p style="margin-bottom: 2.4pt">
					  <b><span style="font-size: 14pt; font-family: 'Arial', sans-serif; color: black; mso-ligatures: standardcontextual;">The John Deere EDI Team has sent you a notification</span></b>
					  <b><span style="font-size: 14pt; font-family: 'Arial', sans-serif; mso-ligatures: standardcontextual;"><o:p></o:p></span></b>
					</p>
					<p style="margin-bottom: 2.4pt">
						<span style="font-size: 10pt; font-family: 'Arial', sans-serif; color: black; mso-ligatures: standardcontextual;">${title}</span>
						<span style="font-size: 10pt; font-family: 'Arial', sans-serif; mso-ligatures: standardcontextual;"><o:p></o:p></span>
					</p>
					<p style="margin-bottom: 2.4pt">
						<span style="font-size: 10pt; font-family: 'Arial', sans-serif; color: black; mso-ligatures: standardcontextual;">${text}</span>
						<span style="font-size: 10pt; font-family: 'Arial', sans-serif; mso-ligatures: standardcontextual;"><o:p></o:p></span>
					</p>
					<p style="margin-bottom: 2.4pt">
						<b><span style="font-size: 10pt; font-family: 'Arial', sans-serif; color: black; mso-ligatures: standardcontextual;">To acknowledge and confirm receipt:
							<a href="https://edi-self-service.deere.com/ediSelfServicePortal/Landing">
							<i><span style="font-size: 11pt; font-family: 'Arial', sans-serif; color: #3b7d23; mso-ligatures: standardcontextual;"> EDI Self Service</span></i></a>
						</span></b>
					</p>
					<p style="margin-bottom: 2.4pt">
					  <span style="font-size: 10pt; font-family: 'Calibri', sans-serif; color: #242424; mso-ligatures: standardcontextual;">&nbsp;</span>
					  <span style="font-size: 11pt; font-family: 'Calibri', sans-serif; mso-ligatures: standardcontextual;"><o:p></o:p></span>
					</p>
					<table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" width="605" style="width: 454.05pt; border-collapse: collapse">
						<tbody>
							<tr style="height: 85.4pt">
								<td width="524" style=" width: 392.75pt; border-top: solid #357c2b 1pt; border-left: none; border-bottom: solid #357c2b 1pt; border-right: none; padding: 0in 5.4pt 0in 5.4pt; height: 85.4pt;box-sizing: border-box;">
									<p style="margin-bottom: 2.4pt">
										<b><i><span style="font-size: 10pt; font-family: 'Arial', sans-serif; color: #357c2b; mso-ligatures: standardcontextual;">We&#8217;d love to hear from you!</span></i></b>
										<span style="font-size: 11pt; font-family: 'Calibri', sans-serif; mso-ligatures: standardcontextual;"><o:p></o:p></span>
									</p>
									<p>
										<span style="font-size: 10pt; font-family: 'Times New Roman', serif;">
											<a href="https://jdsn-contact-us.deere.com/?APPID=EDI">
												<i><span style="font-size: 11pt; font-family: 'Arial', sans-serif; color: #3b7d23; mso-ligatures: standardcontextual;"> Contact US! </span></i>
											</a>
										</span>
									</p>
								</td>
							</tr>
						</tbody>
					</table>
					<p class="MsoNormal">
						<span style="font-size: 10pt; font-family: 'Times New Roman', serif;"><o:p></o:p></span>
					</p>
				</td>
			</tr>
		</tbody>
	</table>
</div>
<p class="MsoNormal"><span style="font-size: 12pt; mso-ligatures: none"><o:p>&nbsp;</o:p></span></p>
<p style="font-family: Calibri; font-size: 10pt; color: #ff0000; margin: 5pt; font-style: normal; font-weight: normal; text-decoration: none;" align="Right">Company Use<br /></p>`}
  return mailData;

};


